import React, { useState } from 'react';
import { UserInfoActions } from '@components/sample-details/UserInfoActions';
import { UserInfoData } from '@components/sample-details/UserInfoData';
import { SampleDetailsDto } from '@src/types/types';
import { classNames } from '@utils/classNames.ts';

interface UserInfoProps {
  sample: SampleDetailsDto;
  forceExpand?: boolean;
  className?: string;
}

export const UserInfo: React.FC<UserInfoProps> = ({
  sample,
  forceExpand,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={classNames(
        'bg-grey3light rounded-xl p-6 flex flex-row',
        className,
      )}
    >
      <UserInfoData sample={sample} isExpanded={forceExpand || isExpanded} />
      <div
        className="flex justify-between cursor-pointer w-max"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <UserInfoActions sample={sample} isExpanded={isExpanded} />
      </div>
    </div>
  );
};
